export const languages = ['en', 'de'];
export const defaultLang = languages[0];
export const langNames = ['EN', 'DE'];
